import { APIGet, APIPost, APIPut, APIDelete, IAPIResponse, APIUrl, AdminType, StatusCode } from "api/protocols";
import { CancelToken } from "axios";
import { ILeague, TLeagueWebTeeTimesDisplay } from "redux/reducers/models/league";
import { TWeekDays } from "components/form/calendarField/helpers";

interface ILeagueGet {
  id?: number | string;
  ids?: Array<number> | Array<string>;
  search?: string;
  year?: number;
  month?: number;
  logo_source?: string;
}

export interface ILeaguePost {
  name?: string;
  week_day?: TWeekDays;
  start_time?: string;
  start_date?: string;
  end_date?: string;
}

export interface ILeaguePut {
  id: number | string;
  name?: string;
  week_day?: TWeekDays;
  start_time?: string;
  description?: string;
  capacity?: number;
  registration_open?: boolean;
  player_limit?: number;
  waitlist_limit?: number;
  start_date?: string;
  end_date?: string;
  /** TODO: Check backend is attached */
  registration_open_date?: string;
  /** TODO: Check backend is attached */
  registration_close_date?: string;
  default_open_structure?: string;
  default_days_in_advance_start?: number;
  default_days_in_advance_end?: number;
  default_open_time?: string;
  enable_custom_booking_window?: boolean;
  minimum_registration_amount?: number;
  maximum_registration_amount?: number;
  web_tee_times_display?: TLeagueWebTeeTimesDisplay;
  online_store?: boolean;
  display_online?: boolean;
  display_registration_online?: boolean;
}

interface IGetLeagueResponse {
  data: ILeague[];
  status: StatusCode;
  message: string;
}

// GET League
// Retrieve a list of leagues
export async function GetLeague(
  params: ILeagueGet,
  useGlobalLoader: boolean,
  token?: CancelToken,
): Promise<IGetLeagueResponse> {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/league"), params, useGlobalLoader, token);
}

// POST League
// Create a new league
export async function PostLeague(params: ILeaguePost, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/league"), params, useGlobalLoader);
}

// PUT League
// Update an existing league
export async function PutLeague(params: ILeaguePut, useGlobalLoader: boolean): Promise<IAPIResponse<ILeague>> {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/league"), params, useGlobalLoader);
}

// PUT League
// Update an existing league
export async function DeleteLeague(params: { id: string | number }, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/league"), params, useGlobalLoader);
}

//League Logo
export async function UploadLeagueLogo(params: any, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/league/logo"), params, useGlobalLoader);
}

export async function DeleteLeagueLogo(params: any, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/league/logo"), params, useGlobalLoader);
}

export async function GetLeagueSponsorship(
  params: { league_id?: string },
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/league/sponsorship"), params, useGlobalLoader, token);
}

export async function PostLeagueSponsorship(params: FormData, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/league/sponsorship"), params, useGlobalLoader);
}

export async function DeleteLeagueSponsorship(params: { id: number }, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/league/sponsorship"), params, useGlobalLoader);
}
